import _ from "lodash";
import { determineSelector, getResource, readUrl, readUrlObjectBased, throwOnApiError, updateResource } from "./api";

const get = async (idOrSlug) => {
  const selector = determineSelector(idOrSlug, { keyId: "profile_id", keySlug: "slug" });
  const url = readUrl("media_profiles", { selector });
  return getResource(url);
};

// Batch-hydrate media profiles by profile_id (the view is keyed on profile_id, not id).
const getAllById = async (ids) => {
  const url = readUrlObjectBased("media_profiles", { conditionParams: { profile_id: `in.(${ids.join(",")})` } });
  return getResource(url);
};

// Name and bio live behind two endpoints (change_name_and_slug + the generic update), so this fires up
// to two sequential PATCHes. throwOnApiError makes the FIRST failing request throw immediately, so we
// never fire the second after a failed first (and never report a masked partial save — e.g. name fails
// but bio succeeds). The caller's try/catch keeps the modal open and surfaces the error.
const updateById = async (id, attributes) => {
  const baseUrl = `/id/api/user_profiles/${id}`;
  // eslint-disable-next-line camelcase
  const { first_name, last_name, ...rest } = attributes;

  let lastResult = { data: {} }; // the default result

  // Update name if either first_name or last_name were non-null
  // eslint-disable-next-line camelcase
  const nameAttributes = _.omitBy({ first_name, last_name }, _.isNil);
  if (!_.isEmpty(nameAttributes)) {
    const nameUrl = `${baseUrl}/change_name_and_slug`;
    lastResult = throwOnApiError(await updateResource(nameUrl, { data: { attributes: nameAttributes } }));
  }

  // Update the rest of the attributes using the generic endpoint
  if (!_.isEmpty(rest)) {
    lastResult = throwOnApiError(await updateResource(baseUrl, { data: { attributes: rest } }));
  }

  // Return the last result as it contains the most up-to-date state of affairs
  return lastResult;
};

export default { get, getAllById, updateById };
